import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const AcademicYearsApi = createApi({
  reducerPath: 'AcademicYearsApi',
  baseQuery,
  tagTypes: ['Academics'],
  endpoints: builder => ({
    getAcademicYears: builder.query({
      query: () => `/manage/academic-years/`,
      providesTags: ['Academics'],
    }),
    createAcademicYear: builder.mutation<any, any>({
      query: newAcademicYear => ({
        url: '/manage/academic-years/',
        method: 'POST',
        body: newAcademicYear,
      }),
      invalidatesTags: ['Academics'],
    }),
    updateAcademicYear: builder.mutation<any, { id: number; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/manage/academic-years/${id}/`,
        method: 'PATCH',
        body: updates,
      }),
      async onQueryStarted({ id, updates }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          AcademicYearsApi.util.updateQueryData(
            'getAcademicYears',
            { search: '', levelId: '', gradeId: '' },
            draft => {
              const academicYearsArray = draft;
              const academicYearToUpdate = academicYearsArray.find(
                (cls: any) => cls.id === id
              );
              if (academicYearToUpdate) {
                Object.assign(academicYearToUpdate, updates);
              }
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (_, __, { id }) => [
        { type: 'Academics', id },
        'Academics',
      ],
    }),
  }),
});

export const {
  useGetAcademicYearsQuery,
  useCreateAcademicYearMutation,
  useUpdateAcademicYearMutation,
} = AcademicYearsApi;
